const SvgFilter = () => (
	<svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M12 7h8M4 7h4M17 17h3M4 17h8" stroke="#100D3D" strokeWidth={1.5} strokeLinecap="round" />
		<circle cx={10} cy={7} r={2} transform="rotate(90 10 7)" stroke="#100D3D" strokeWidth={1.5} strokeLinecap="round" />
		<circle
			cx={15}
			cy={17}
			r={2}
			transform="rotate(90 15 17)"
			stroke="#100D3D"
			strokeWidth={1.5}
			strokeLinecap="round"
		/>
	</svg>
)

export default SvgFilter
